export default __webpack_public_path__ + "static/media/emilyz.48a62490.jpg";